import api from '@/api';
export const getCategory = async (categoryId) => {
    const { data } = await api.get(`categories/${categoryId}`);
    return data;
};
